import { LatLng } from '@agm/core';

export class Fields {
    id: number;
    name: string;
    owner: string;
    campaignId: number;
    cropId: number;
    hectares: number;
    cropHectare: number;
    branchOfficeId: number;
    advisorId: number;
    classificationId: number;
    continuation: boolean;
    observation: string;
    coordinates: Array<LatLng>;
}
